import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccessDenied = _resolveComponent("AccessDenied")!
  const _component_GridIndex = _resolveComponent("GridIndex")!

  return (!_ctx.permissaoTela.visualizar)
    ? (_openBlock(), _createBlock(_component_AccessDenied, {
        key: 0,
        msg: "Você não tem permissão para visualizar esta tela. Caso precise de acesso, procure o suporte."
      }))
    : (_openBlock(), _createBlock(_component_GridIndex, { key: 1 }))
}